const icons = [
"cash-drawer-closed",
"cash-drawer-open",
"expense",
"deposit",
"daily-closing",
"daily-closing-preview",
"daily-opening",
"sales-receipt",
"receipt-designer",
"client-settings",
"server-settings",
"sales",
"operator",
"operator-login",
"operator-logout",
"tap-and-till",
"mate",
"pos-ux",
"operator-switch",
"sales-receipt-discard",
"sales-receipt-canceled",
"cash-register",
"bank",
"bank-income",
"document-stuck",
"document-advance-payment",
"document-deposit",
"document-service",
"document-credit-note",
"document-report",
"document-expense",
"sales-receipt-processing",
"turnover",
"customer",
"time-clock",
"time-clock-detail",
"first-name",
"last-name",
"ticket-vip",
"magnifying-heart",
"left-handed",
"right-handed",
"hand-left",
"customer-plus",
"cash-register-locked",
"cash-register-warning",
"mate-alt",
"bridge-alt",
"bridge",
"advance-payment",
"advance-payment-redeem",
"advance-payment-ready",
"advance-payment-payback",
"payment",
"inventory-recount",
"inventory-annual",
"inventory-sampling",
"inventory-finish",
"inventory-cancel",
"report",
"report-cancelation",
"article-search",
"article-discount",
"article-info",
"article-history",
"home-folder",
"article-price-reduction",
"article-add",
"article-price-change",
"article-filter",
"article-split",
"article-season",
"bank-charges",
"bank-absorption",
"bank-payment-in",
"bank-payment-out",
"credit-note",
"credit-note-redeemed",
"credit-note-payback",
"hexagon-exclamation",
"stock-never-out",
"stock-closed",
"stock-query",
"logistic-relocation",
"logistic-relocation-demand",
"hardware-online-upload-download",
"hardware-online-upload",
"hardware-online-download",
"hardware-online",
"hardware-offline-upload-download",
"hardware-offline-upload",
"hardware-offline-download",
"hardware-offline",
"scanner-off",
"barcode-printer",
"keyboard-cap-alpha",
"keyboard-cap-numeric",
"keyboard-cap-alpha-alt",
"keyboard-cap-numeric-alt",
"journal",
"database-restore",
"goods-return",
"payment-terminal",
"article-tablo",
"foreign-currency",
"scanner-gun-off",
"cloud-sync",
"storno",
"stop",
"postage-stamp",
"postage-stamp-alt",
"refresh",
"set",
"capslock-on",
"capslock-off",
"shift",
"tab",
"tab-reverse",
"barcode-printer-off",
"barcode-printer-paper-out",
"barcode-printer-cover-up",
"barcode-printer-fiscal",
"database-import",
"last-page",
"first-page",
"file-send",
"zip-code",
"filter-reset",
"baket-shopping-slash",
"pictogram-grid",
"folder-document",
"chess-rook-piece-slash",
"phone-bell",
"numbers",
"box",
"box-slash",
"user-folder",
"magnify-user",
"user-communication",
"stores",
"file-customer",
"users",
"reservation",
"user",
"trucks",
"signpad",
"sqaures-checks",
"sqaures",
"store-lock",
"hand-holding-basket-shopping",
"material",
"price-range",
"user-basket-repair",
"file-chart-line-up",
"file-advance-payment",
"file-rudder",
"file-user-box",
"banknotes-coins",
"banknotes-coins-mixed",
"slash-percent",
"voucher",
"voucher-redeemed",
"voucher-payback",
"goods-shop",
"gift-card",
"box-arrow-calendar",
"inkscape-test",
"paypal-brand",
"paypal-alt",
"mastercard",
"visa",
"alipay",
"alipay-alt",
"google-pay",
"google-pay-brands",
"google-wallet-brands",
"apple-pay",
"apple-pay-brands",
"ammex-alt",
"ammex",
"amazon-pay",
"klarna",
"klarna-alt",
"jcb",
"stripe",
"discover",
"blue-code",
"blue-code-alt",
"blue-code-brands",
"dinners-club",
"sales-alt",
];
export default icons;